module.exports = __webpack_public_path__ + "static/img/17.ed4f7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/17.png
// module id = w9sq
// module chunks = 73